import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_backoffice_custom = _resolveComponent("backoffice-custom")!
  const _component_club_subscription_confirmed = _resolveComponent("club-subscription-confirmed")!
  const _component_club_vacation_booking_answer = _resolveComponent("club-vacation-booking-answer")!
  const _component_money_transfer_received = _resolveComponent("money-transfer-received")!
  const _component_monthly_commission_paid = _resolveComponent("monthly-commission-paid")!
  const _component_new_chat_message = _resolveComponent("new-chat-message")!
  const _component_new_registration_with_your_code = _resolveComponent("new-registration-with-your-code")!
  const _component_village_trip_book_answer = _resolveComponent("village-trip-book-answer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.item.type == 'BackofficeCustom')
      ? (_openBlock(), _createBlock(_component_backoffice_custom, {
          key: 0,
          onClicked: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clicked'))),
          item: _ctx.item
        }, null, 8, ["item"]))
      : _createCommentVNode("", true),
    (_ctx.item.type == 'ClubSubscriptionConfirmed')
      ? (_openBlock(), _createBlock(_component_club_subscription_confirmed, {
          key: 1,
          onClicked: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('clicked'))),
          item: _ctx.item
        }, null, 8, ["item"]))
      : _createCommentVNode("", true),
    (_ctx.item.type == 'ClubVacationBookingAnswer')
      ? (_openBlock(), _createBlock(_component_club_vacation_booking_answer, {
          key: 2,
          onClicked: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('clicked'))),
          item: _ctx.item
        }, null, 8, ["item"]))
      : _createCommentVNode("", true),
    (_ctx.item.type == 'MoneyTransferReceived')
      ? (_openBlock(), _createBlock(_component_money_transfer_received, {
          key: 3,
          onClicked: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('clicked'))),
          item: _ctx.item
        }, null, 8, ["item"]))
      : _createCommentVNode("", true),
    (_ctx.item.type == 'MonthlyCommissionsPaid')
      ? (_openBlock(), _createBlock(_component_monthly_commission_paid, {
          key: 4,
          onClicked: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('clicked'))),
          item: _ctx.item
        }, null, 8, ["item"]))
      : _createCommentVNode("", true),
    (_ctx.item.type == 'NewChatMessage')
      ? (_openBlock(), _createBlock(_component_new_chat_message, {
          key: 5,
          onClicked: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('clicked'))),
          item: _ctx.item
        }, null, 8, ["item"]))
      : _createCommentVNode("", true),
    (_ctx.item.type == 'NewRegistrationWithYourCode')
      ? (_openBlock(), _createBlock(_component_new_registration_with_your_code, {
          key: 6,
          onClicked: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('clicked'))),
          item: _ctx.item
        }, null, 8, ["item"]))
      : _createCommentVNode("", true),
    (_ctx.item.type == 'VillageTripBookAnswer')
      ? (_openBlock(), _createBlock(_component_village_trip_book_answer, {
          key: 7,
          onClicked: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('clicked'))),
          item: _ctx.item
        }, null, 8, ["item"]))
      : _createCommentVNode("", true)
  ], 64))
}